import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

export function useFiltersInURL<T>(filters: T): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(filters)

  const { push, pathname, query } = useRouter()

  useEffect(() => {
    const newQuery = { ...state, ...query }
    setState(newQuery)
  }, [])

  useEffect(() => {
    let newQuery = {}
    if (JSON.stringify(state) === JSON.stringify(filters)) {
      newQuery = { ...state, ...query }
    } else {
      newQuery = { ...query, ...state }
    }

    push({
      pathname,
      query: newQuery,
    })
  }, [state])

  return [state, setState]
}
